import DismissableModal from './DismissableModal';

export default DismissableModal;
